module.exports = __webpack_public_path__ + "img/user-circle.3346de4c.svg";